module.exports = __webpack_public_path__ + "img/gooey-ring-loader.a1dd854b.svg";